<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<form (ngSubmit)='onSubmit()' [formGroup]='form'>
  <div class='row mt-sm mx-none'>
    <div class='col-12'>

      <div class='col-12 col-lg-6'>
        <well-person-inputs #personForm
                            [disabled]='disabledPersonFormGroup'
                            [person]="form.controls['personDTO'].value"
                            [showOnlyName]='showOnlyPersonName' data-testid="person-inputs-input">
        </well-person-inputs>
      </div>

      <div class='col-12'>
        <div class='col-12 col-lg-6 form-field mb'>
              <p-floatlabel variant="on">
                <input formControlName='phoneNumber' id='phoneNumber' pInputText style='width: 100%'
                       [maxLength]='20'
                       formInlineError='contactManagement.error' type='text' wellInputTrim data-testid="phone-number-input"/>
                <label
                  for='phoneNumber'>{{ 'contactManagement.inputs.phoneNumber' | translate }} {{ (this.phoneNumberRequired && this.phoneNumberFormControl.validator) ? ' *' : '' }}</label>
              </p-floatlabel>
        </div>

        <div class='pb'>
          <div class='col-12 col-lg-6 form-field'>
              <p-floatlabel variant="on">
                <input formControlName='email' id='email' pInputText style='width: 100%' wellInputTrim
                       [maxLength]='50'
                       formInlineError='contactManagement.error' type='text' data-testid="email-input"/>
                <label for='email'>{{ 'contactManagement.inputs.email' | translate }}
                  <span>{{ (this.emailRequired && this.emailFormControl.validator) ? ' *' : '' }}</span></label>
              </p-floatlabel>
          </div>
        </div>

        <div class='pb'>
          <div class='col-12 col-lg-6 form-field flex-row-forced align-items-center'>
            <p-toggleswitch formControlName='receivesRequests' [readonly]='!!meta?.phoneNumberRequired' data-testid="receives-requests-toggle"></p-toggleswitch>
            <label class='ml-sm'>{{ 'contactManagement.inputs.receivesRequests' | translate }}</label>
          </div>
        </div>

        <div class='pb'>
          <div class='col-12 col-lg-6' pTooltip="{{'contactManagement.receivesRequestsRequiredTooltip' | translate}}"
               [tooltipDisabled]='receivesRequestsFormControl.value'>
              <p-floatlabel variant="on">
                <p-select [options]='contactMethods' [style]="{width: '100%'}" appendTo='body'
                            [autoDisplayFirst]='false'
                            [baseZIndex]='10000'
                            [readonly]='!!meta?.phoneNumberRequired'
                            formInlineError='contactManagement.error'
                            [disabled]='!receivesRequestsFormControl.value'
                            formControlName='contactMethod' id='contactMethod' data-testid="contact-method-select">
                </p-select>
                <label
                  for='contactMethod'>{{ 'contactManagement.inputs.contactMethod' | translate }}  {{ (this.contactMethodRequired && this.contactMethodFormControl.validator) ? ' *' : '' }}</label>
              </p-floatlabel>
          </div>
        </div>

        <div *ngIf='displayVisibilityField'>
          <div class='col-12 col-lg-6'>
            <div class='col-12 pb'>
                <p-floatlabel variant="on">
                  <p-select [options]='visibilityTypes'
                              [style]="{width: '100%'}"
                              [baseZIndex]='10000'
                              [autoDisplayFirst]='false'
                              appendTo='body'
                              formControlName='visibilityType'
                              formInlineError='contactManagement.error'
                              id='visibilityType' data-testid="visibility-type-select">
                  </p-select>
                  <label for='visibilityType'>{{ 'contactManagement.inputs.visibilityType' | translate }} *</label>
                </p-floatlabel>
              <span
                *ngIf='visibilityTypeFormControl.value'>{{ translationSchema.utils.visibilityTypeDescription[visibilityTypeFormControl.value] | translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>



